enum AccountCreationStep {
  WELLEVATE_AUTH = "authenticate",
  ACCOUNT_DETAILS = "details",
  ACCOUNT_CREATION = "create",
  ACCOUNT_ERROR = "error",
}

export { AccountCreationStep };
